import React, { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './LoginPage.css'; // Custom CSS for additional styling

const Otp = () => {
  const location = useLocation();
  const { uotp, mobile } = location.state || {};
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const inputRefs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
  const navigate = useNavigate();

  React.useEffect(() => {
    let interval;
    if (timer > 0 && !canResend) {
      interval = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
    } else if (timer === 0 && !canResend) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer, canResend]);

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleBackspace = (key, index) => {
    if (key === 'Backspace' && index > 0 && !otp[index]) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handleResend = async () => {
    if (!canResend) return;
    
    setCanResend(false);
    setTimer(30);
    
    try {
      const formData = new FormData();
      formData.append('mobile', mobile);
      
      const response = await fetch('https://singlewindowsecurities.com/rest3/web_login_api', {
        method: 'POST',
        body: formData,
      });
      
      const result = await response.json();
      if (result.status == 0) {
        alert('OTP resent successfully');
        // Update uotp if needed
      } else {
        alert('Failed to resend OTP');
        setCanResend(true);
      }
    } catch (error) {
      alert('Failed to resend OTP');
      setCanResend(true);
    }
  };

  const verifyOTP = async (e) => {
    e.preventDefault();
    const otpCode = otp.join('');
    if (otpCode!=uotp) {
      alert('Please enter valid 6-digit OTP.');
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('mobile', mobile);
      formData.append('otp', otpCode);

      const response = await fetch(
        'https://singlewindowsecurities.com/rest3/web_otp_verify_api',
        {
          method: 'POST',
          body: formData,
        }
      );

      const data = await response.json();
      console.log(data);
      
      localStorage.setItem('userid', data.id);
      localStorage.setItem('name', data.first_name);
      localStorage.setItem('email', data.email);
      localStorage.setItem('mobile', data.mobile);

      navigate('/dashboard');
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="otp-page" style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)',
      position: 'relative',
      overflowX: 'hidden'
    }}>
      {/* Background Gradient Effects */}
      <div className="gradient-bg-top" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '300px',
        background: 'radial-gradient(circle at 50% 0%, rgba(212, 175, 55, 0.08), transparent)',
        pointerEvents: 'none'
      }}></div>
      <div className="gradient-bg-bottom" style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '300px',
        background: 'radial-gradient(circle at 50% 100%, rgba(212, 175, 55, 0.05), transparent)',
        pointerEvents: 'none'
      }}></div>

      <div className="container" style={{ paddingTop: '60px', paddingBottom: '60px' }}>
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-10">
            {/* Header */}
            <header style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '30px'
            }}>
              <button 
                onClick={() => navigate(-1)}
                style={{
                  background: 'rgba(212, 175, 55, 0.1)',
                  border: '1px solid rgba(212, 175, 55, 0.3)',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#D4AF37',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(212, 175, 55, 0.2)';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(212, 175, 55, 0.1)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <i className="fas fa-arrow-left"></i>
              </button>
              
              <h1 style={{
                color: '#D4AF37',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                letterSpacing: '2px',
                margin: 0
              }}>OTP Verification</h1>
              
              <div className="spacer" style={{ width: '40px' }}></div>
            </header>

            {/* Verification Card */}
            <div style={{
              background: 'rgba(20, 20, 20, 0.95)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(212, 175, 55, 0.2)',
              borderRadius: '24px',
              padding: '30px',
              textAlign: 'center',
              marginBottom: '24px'
            }}>
              <div style={{
                background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                width: '70px',
                height: '70px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px'
              }}>
                <i className="fas fa-sms" style={{ fontSize: '30px', color: '#000' }}></i>
              </div>
              
              <h2 style={{
                color: '#D4AF37',
                fontSize: '1.3rem',
                fontWeight: 'bold',
                marginBottom: '12px'
              }}>Enter Verification Code</h2>
              
              <p style={{ color: '#888', margin: 0 }}>
                We've sent a 6-digit code to <span style={{ color: '#D4AF37', fontWeight: 'bold' }}>{mobile}</span>
              </p>
            </div>

            {/* OTP Form */}
            <form onSubmit={verifyOTP}>
              {/* OTP Input Section */}
              <div style={{ marginBottom: '24px' }}>
                <label style={{
                  display: 'block',
                  color: '#D4AF37',
                  fontSize: '0.75rem',
                  fontWeight: 'bold',
                  letterSpacing: '2px',
                  marginBottom: '12px'
                }}>ENTER OTP</label>
                
                <div style={{
                  display: 'flex',
                  gap: '12px',
                  justifyContent: 'center'
                }}>
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={inputRefs[index]}
                      type="text"
                      className="otp-digit"
                      maxLength="1"
                      inputMode="numeric"
                      value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleBackspace(e.key, index)}
                      style={{
                        width: '50px',
                        height: '55px',
                        textAlign: 'center',
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        background: '#1a1a1a',
                        border: digit ? '2px solid #D4AF37' : '1px solid rgba(212, 175, 55, 0.3)',
                        borderRadius: '12px',
                        color: '#D4AF37',
                        transition: 'all 0.2s ease'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#D4AF37';
                        e.target.style.boxShadow = '0 0 0 2px rgba(212, 175, 55, 0.3)';
                      }}
                      onBlur={(e) => {
                        if (!digit) {
                          e.target.style.borderColor = 'rgba(212, 175, 55, 0.3)';
                        }
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  ))}
                </div>
              </div>

              {/* Submit Button */}
              <button 
                type="submit" 
                disabled={loading}
                style={{
                  width: '100%',
                  background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                  border: 'none',
                  padding: '14px',
                  borderRadius: '12px',
                  color: '#000',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  letterSpacing: '2px',
                  transition: 'all 0.3s ease',
                  marginBottom: '20px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 5px 20px rgba(212, 175, 55, 0.3)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!loading) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }
                }}
              >
                {loading ? (
                  <div className="spinner-border spinner-border-sm" role="status" style={{ color: '#000' }}>
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (
                  'VERIFY OTP'
                )}
              </button>

              {/* Resend OTP */}
              <div style={{ textAlign: 'center' }}>
                <p style={{ color: '#888', margin: 0 }}>
                  Didn't receive the OTP?{' '}
                  <button 
                    type="button" 
                    onClick={handleResend}
                    disabled={!canResend}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: canResend ? '#D4AF37' : '#555',
                      fontWeight: 'bold',
                      cursor: canResend ? 'pointer' : 'not-allowed',
                      transition: 'color 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      if (canResend) e.target.style.color = '#E0C350';
                    }}
                    onMouseLeave={(e) => {
                      if (canResend) e.target.style.color = '#D4AF37';
                    }}
                  >
                    {canResend ? 'Resend Now' : `Resend in ${timer}s`}
                  </button>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style>
        {`
          .otp-digit:focus {
            outline: none;
          }
        `}
      </style>
    </div>
  );
};

export default Otp;